import React from 'react'
import { groupBy } from 'lodash-es'
import Day from './day'
import DateRange from '../../entities/date-range'
import AnimalEncounters from '../day/animal-encounters'
import FourDExperiences from '../day/4d-experiences'
import DateRangeFormatter from '../../helpers/date-range-formatter'
import { DateTime } from 'luxon'

import { Header, ErrorMessage, Overlay, DataProvider } from '../../components'
import { Loading, LoadingIcon } from '../../../shared/components'
import { routerProps } from '../../services/router-props'

function filmsByTitle(days) {
  if (!days || !days.length) {
    return []
  } else {
    let entries = days[0].entries

    return groupBy(
      entries.filter(e => e.resourceType && e.resourceType === 'FourDFilm'),
      film => film.title
    )
  }
}

class Week extends React.Component {
  state = {
    date: null,
    data: null,
    loading: true,
    error: null,
    dateRange: null
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.date !== nextProps.date) {
      let date = DateTime.fromISO(nextProps.date, { zone: 'America/Chicago' })

      return {
        dateRange: new DateRange(date).expand(),
        date: nextProps.date
      }
    }

    return null
  }

  navigate = date => {
    this.props.navigate(`/calendar/week/${date}`)
  }

  render() {
    let { navigate } = this.props
    let { loading, dateRange } = this.state

    return (
      <React.Fragment key="rootFragment">
        <DataProvider
          dateRange={dateRange}
          onRequest={this.handleLoadStart}
          onSuccess={this.handleSuccess}
          onError={this.handleError}
        />

        <Header
          key="header"
          dateRange={dateRange}
          navigate={navigate}
          navigateRelative={this.navigate}
        >
          <LoadingIcon visible={loading} />
        </Header>

        <Overlay visible={loading}>{this.renderWeekView()}</Overlay>
      </React.Fragment>
    )
  }

  renderWeekView() {
    let { data, error, loading, dateRange } = this.state

    if (!dateRange || (loading && !data)) {
      return <Loading />
    }

    if (error) {
      return <ErrorMessage />
    }

    let { days, animalEncounters } = data
    let films = filmsByTitle(days)

    return (
      <div className="lg:px-24 xl:max-w-xl xl:mx-auto xl:px-40">
        <div className="mb-60 md:mb-80 lg:flex lg:items-stretch">
          <p
            role="alert"
            className="sr-only"
          >
            Events loaded for{' '}
            {DateRangeFormatter.toShortString(this.state.dateRange)}
          </p>

          {days.map((day, i) => (
            <Day
              key={i}
              day={day}
              position={i}
            />
          ))}
        </div>
        <AnimalEncounters encounters={animalEncounters} />
        <FourDExperiences films={films} />
      </div>
    )
  }

  handleLoadStart = () => {
    this.setState({ loading: true })
  }

  handleSuccess = data => {
    this.setState({ loading: false, error: null, data })
  }

  handleError = error => {
    this.setState({ loading: false, error })
  }
}

export default routerProps(Week)
